import { z } from 'zod';

const inventoryEntityItem = z.object({
  tag: z.string(),
});

const inventoryTimeseriesItem = z.object({
  snake: z.string(),
});

const inventoryWebLinkItem = z.object({
  urls: z.array(z.string()).nullish(),
});

const inventoryExternalDataItem = z.object({
  links: z.array(z.string()).nullish(),
});

const inventoryArtifactItem = z.object({
  artifact_id: z.string(),
});

const inventoryNewsItem = z.object({
  article_id: z.string(),
  title: z.string(),
});

const inventoryInsightItem = z.object({
  id: z.string(),
});

const financialStatementsItem = z.object({
  tag: z.string(),
});

const documentSchema = z.object({
  Authority: z.number(),
  Country: z.string(),
  Entity: z.string(),
  ID: z.string(),
  Kind: z.string(),
  Rank: z.number(),
});

export type DocumentSearchSchema = z.infer<typeof documentSchema>;

const documentSearchItem = z.object({
  question: z.string().optional(),
  citation_groups: z.array(z.string()).nullish(),
  documents: z.array(documentSchema).nullish(),
});

export type DocumentSearchItem = z.infer<typeof documentSearchItem>;

const conversationInventorySchema = z.object({
  entity: z.object({ items: z.array(inventoryEntityItem) }).optional(),
  timeseries: z.object({ items: z.array(inventoryTimeseriesItem) }).optional(),
  artifact: z.object({ items: z.array(inventoryArtifactItem) }).optional(),
  insight: z.object({ items: z.array(inventoryInsightItem) }).optional(),
  news: z.object({ items: z.array(inventoryNewsItem) }).optional(),
  ['web-links']: z.object({ items: z.array(inventoryWebLinkItem) }).optional(),
  ['external-data']: z
    .object({ items: z.array(inventoryExternalDataItem) })
    .optional(),
  ['financial-statement']: z
    .object({ items: z.array(financialStatementsItem) })
    .optional(),
  ['document-search']: z
    .object({ items: z.array(documentSearchItem) })
    .optional(),
});

export const inventory = {
  conversationInventory: {
    path: (conversationId: string) =>
      `conversation-inventory/v1/conversations/${conversationId}`,
    schema: conversationInventorySchema,
  },
};
